import './TicketsOverview.less';

import { List } from 'immutable';
import React, { useEffect } from 'react';
import { dispatchSync, useReframe, dispatch } from 'nike-re-framejs';
import i18n from '@i18n';

import InfiniteScroll from '@/responsive/components/InfiniteScroll/InfiniteScroll';
import TicketsOverviewFilterButton from './TicketsOverviewFilter';
import EmptyState from 'nike-ui/src/components/empty-state/EmptyState';
import TicketPage from '@/mytickets/components/ticket-page/TicketPage';
import TicketGroup from '@/mytickets/components/ticket-group/TicketGroup';
import { todayMonthOthers } from '@/mytickets/utils';
import { TicketLoginForm } from '@/mytickets/components/ticket-login-form/TicketLoginForm';
import TicketsOverviewLoader from '@/mytickets/overview/views/TicketsOverviewLoader';
import LoaderMini from '@/ui/views/LoaderMini';
import { MY_TICKETS } from '@/routing/routes';
import { loggedIn$ } from '@/account/subs';
import TicketIcon from '@/icons/TicketIcon';

function TicketsOverview({ matchId = null, showHeader = true, autoHeight = false }) {
    useEffect(() => {
        dispatch(['ticketus/overview/initialize', matchId]);
    }, [matchId]);
    const { derefSub, subscribe } = useReframe();
    const loggedIn = subscribe(loggedIn$);
    const pageList = derefSub(['ticketus/overview/list']);

    if (!pageList || !pageList.get('data')) {
        return <TicketsOverviewLoader />;
    }

    const tickets = pageList.get('data') || List();
    const hasNextPage = pageList.get('hasNextPage');

    const empty = (
        <EmptyState
            stateIcon={autoHeight ? null : <TicketIcon width={60} height={60} fill={'#aab2bd'} />}
            text={i18n('ticketus.overview.notickets')}
            className={autoHeight ? 'py-30' : ''}
        />
    );

    return (
        <MobileTabletTicketsOverview
            loggedIn={loggedIn}
            tickets={tickets}
            hasNextPage={hasNextPage}
            empty={empty}
            showHeader={showHeader}
            autoHeight={autoHeight}
        />
    );
}

function MobileTabletTicketsOverview({ loggedIn, tickets, hasNextPage, empty, showHeader, autoHeight }) {
    const derefSub = useReframe();
    const filterStatus = derefSub(['ticketus/overview/filter/status']);
    const [todayTickets, monthTickets, otherTickets] = todayMonthOthers(tickets);
    const filters = showHeader ? <TicketsOverviewFilterButton /> : null;
    if (!loggedIn) {
        return (
            <div className="tickets-overview-login page-wrap layout-rw">
                <TicketLoginForm />
            </div>
        );
    }

    if (filterStatus === 'Cashin') {
        return (
            <TicketPage active={MY_TICKETS} filters={filters} autoHeight={autoHeight}>
                {tickets.size ? (
                    <div className="ticket-content">
                        <TicketGroup label={i18n('commons.datum.dnes')} tickets={todayTickets} />
                        <TicketGroup label={i18n('commons.datum.tentoMesiac')} tickets={monthTickets} />
                        <TicketGroup label={i18n('commons.datum.starsie')} tickets={otherTickets} />
                    </div>
                ) : (
                    empty
                )}
            </TicketPage>
        );
    }

    return (
        <TicketPage active={MY_TICKETS} filters={filters} autoHeight={autoHeight}>
            {tickets.size ? (
                <InfiniteScroll
                    className="ticket-content"
                    pageStart={0}
                    hasMore={hasNextPage}
                    loadMore={() => dispatchSync(['ticketus/overview/load-more'])}
                    loader={<LoaderMini className="infinite-loader tickets-load-more-loader" key="loader" />}
                    threshold={0}
                    useWindow
                >
                    <TicketGroup label={i18n('commons.datum.dnes')} tickets={todayTickets} />
                    <TicketGroup label={i18n('commons.datum.tentoMesiac')} tickets={monthTickets} />
                    <TicketGroup label={i18n('commons.datum.starsie')} tickets={otherTickets} />
                </InfiniteScroll>
            ) : (
                empty
            )}
        </TicketPage>
    );
}

export default TicketsOverview;
